import { useState } from "react";
import { IRestaurant } from "../models/IRestaurant";
import { S3_IMAGE_BASE_URL } from "../config/restaurantConfig";

interface Props {
  restaurant: IRestaurant | null;
}

function scrollTo(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
}

const LINKS = [
  { id: "top", label: "Anasayfa" },
  { id: "hakkimizda", label: "Hakkımızda" },
  { id: "menu", label: "Menü" },
  { id: "rezervasyon", label: "Rezervasyon" },
];

export default function Navbar({ restaurant }: Props) {
  const [open, setOpen] = useState(false);

  const go = (id: string) => {
    setOpen(false);
    scrollTo(id);
  };

  return (
    <>
      <nav className="rr-navbar">
        <a
          href="#top"
          className="rr-navbar-brand"
          onClick={(e) => { e.preventDefault(); go("top"); }}
        >
          {restaurant?.restourantLogoPath && (
            <img src={S3_IMAGE_BASE_URL + restaurant.restourantLogoPath} alt={restaurant.restourantName} />
          )}
          {restaurant?.restourantName ?? "Restoran"}
        </a>

        <div className="rr-nav-links">
          {LINKS.map((l) => (
            <a key={l.id} href={`#${l.id}`} onClick={(e) => { e.preventDefault(); go(l.id); }}>
              {l.label}
            </a>
          ))}
        </div>

        <button
          type="button"
          className="rr-nav-toggle"
          aria-label="Menü"
          onClick={() => setOpen((v) => !v)}
        >
          <i className={`bi ${open ? "bi-x-lg" : "bi-list"}`}></i>
        </button>
      </nav>

      <div className={`rr-mobile-backdrop${open ? " show" : ""}`} onClick={() => setOpen(false)} />
      <div className={`rr-mobile-menu${open ? " show" : ""}`}>
        {LINKS.map((l) => (
          <a key={l.id} href={`#${l.id}`} onClick={(e) => { e.preventDefault(); go(l.id); }}>
            {l.label}
          </a>
        ))}
      </div>
    </>
  );
}
